// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sendresponsemater-container {
  max-width: 900px;
  margin: auto;
  padding: 1.5rem;
  font-family: "Inter", sans-serif;
}

.sendresponsemater-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #1e40af;
}

.sendresponsemater-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.sendresponsemater-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
}

.sendresponsemater-table th,
.sendresponsemater-table td {
  text-align: left;
  padding: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.sendresponsemater-table th {
  background-color: #f3f4f6;
  font-weight: 600;
  color: #374151;
}

.sendresponsemater-table td {
  color: #1f2937;
}

.sendresponsemater-footer {
  background: #f9fafb;
  padding: 1rem;
  border-left: 4px solid #3b82f6;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #374151;
  margin-bottom: 1rem;
}

.sendresponsemater-button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.sendresponsemater-update-btn {
  background-color: #2563eb;
  color: #fff;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.sendresponsemater-update-btn:hover {
  background-color: #1d4ed8;
}

.sendresponsemater-loading {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: #6b7280;
}

/* Responsive */
@media (max-width: 768px) {
  .sendresponsemater-table thead {
    display: none;
  }

  .sendresponsemater-table tr {
    display: block;
    margin-bottom: 1rem;
    border-bottom: 2px solid #e5e7eb;
  }

  .sendresponsemater-table td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    font-size: 0.95rem;
  }

  .sendresponsemater-update-btn {
    width: 100%;
  }
}

.sendresponsemater-form {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1.5rem;
  padding: 1rem 0;
}

.sendresponsemater-form-group {
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
}

.sendresponsemater-form-group label {
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.sendresponsemater-form-group input {
  padding: 0.65rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.3s ease;
}

.sendresponsemater-form-group input:focus {
  border-color: #0b72b9;
  outline: none;
}

/* Responsive */
@media (max-width: 768px) {
  .sendresponsemater-form-group {
    flex: 1 1 100%;
  }
}
.sendresponsemater-cancel-btn {
  background-color: #999;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  margin-left: 0.75rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.sendresponsemater-cancel-btn:hover {
  background-color: #777;
}

@media (max-width: 768px) {
  .sendresponsemater-button-wrapper {
    flex-direction: column;
    gap: 0.75rem;
  }

  .sendresponsemater-update-btn,
  .sendresponsemater-cancel-btn {
    width: 100%;
    margin-left: 0;
  }
}

.sendresponsemater_send_to_pricing {
  margin-left: 10px;
  background-color: #2563eb;
  color: #fff;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Overlay */
.sendresponsemater-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.sendresponsemater-pricing-list {
  background-color: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  animation: fadeInScale 0.3s ease-in-out;
}

@keyframes fadeInScale {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.sendresponsemater-pricing-list-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.sendresponsemater-multiselect-wrapper {
  margin-bottom: 1.5rem;
}

.sendresponsemater-multiselect-wrapper label {
  display: block;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #444;
}

.sendresponsemater-multiselect {
  width: 100%;
  height: 140px;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  outline: none;
}

.sendresponsemater-multiselect option {
  padding: 0.5rem;
}

.sendresponsemater-close-pricing-list,
.sendresponsemater-send-to-pricing-btn {
  background-color: #0052cc;
  color: #fff;
  border: none;
  padding: 0.6rem 1.2rem;
  margin-left: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.sendresponsemater-close-pricing-list {
  background-color: #ccc;
  color: #333;
}

.sendresponsemater-send-to-pricing-btn:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.sendresponsemater-close-pricing-list:hover {
  background-color: #999;
}

.sendresponsemater-send-to-pricing-btn:hover:not(:disabled) {
  background-color: #0040a0;
}

@media (max-width: 480px) {
  .sendresponsemater-pricing-list {
    padding: 1.2rem;
  }

  .sendresponsemater-pricing-list-title {
    font-size: 1.25rem;
  }

  .sendresponsemater-multiselect {
    height: 120px;
  }

  .sendresponsemater-close-pricing-list,
  .sendresponsemater-send-to-pricing-btn {
    width: 100%;
    margin: 0.3rem 0;
  }

  div[style*="text-align: right"] {
    text-align: center !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Perches/SendResponseMater.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".sendresponsemater-container {\n  max-width: 900px;\n  margin: auto;\n  padding: 1.5rem;\n  font-family: \"Inter\", sans-serif;\n}\n\n.sendresponsemater-title {\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 2rem;\n  color: #1e40af;\n}\n\n.sendresponsemater-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.sendresponsemater-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.5rem;\n}\n\n.sendresponsemater-table th,\n.sendresponsemater-table td {\n  text-align: left;\n  padding: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.sendresponsemater-table th {\n  background-color: #f3f4f6;\n  font-weight: 600;\n  color: #374151;\n}\n\n.sendresponsemater-table td {\n  color: #1f2937;\n}\n\n.sendresponsemater-footer {\n  background: #f9fafb;\n  padding: 1rem;\n  border-left: 4px solid #3b82f6;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  color: #374151;\n  margin-bottom: 1rem;\n}\n\n.sendresponsemater-button-wrapper {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.sendresponsemater-update-btn {\n  background-color: #2563eb;\n  color: #fff;\n  padding: 0.6rem 1.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.sendresponsemater-update-btn:hover {\n  background-color: #1d4ed8;\n}\n\n.sendresponsemater-loading {\n  text-align: center;\n  padding: 2rem;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sendresponsemater-table thead {\n    display: none;\n  }\n\n  .sendresponsemater-table tr {\n    display: block;\n    margin-bottom: 1rem;\n    border-bottom: 2px solid #e5e7eb;\n  }\n\n  .sendresponsemater-table td {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.95rem;\n  }\n\n  .sendresponsemater-update-btn {\n    width: 100%;\n  }\n}\n\n.sendresponsemater-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n  padding: 1rem 0;\n}\n\n.sendresponsemater-form-group {\n  flex: 1 1 45%;\n  display: flex;\n  flex-direction: column;\n}\n\n.sendresponsemater-form-group label {\n  font-size: 0.95rem;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.sendresponsemater-form-group input {\n  padding: 0.65rem;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  transition: border-color 0.3s ease;\n}\n\n.sendresponsemater-form-group input:focus {\n  border-color: #0b72b9;\n  outline: none;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sendresponsemater-form-group {\n    flex: 1 1 100%;\n  }\n}\n.sendresponsemater-cancel-btn {\n  background-color: #999;\n  color: white;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  margin-left: 0.75rem;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.sendresponsemater-cancel-btn:hover {\n  background-color: #777;\n}\n\n@media (max-width: 768px) {\n  .sendresponsemater-button-wrapper {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .sendresponsemater-update-btn,\n  .sendresponsemater-cancel-btn {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n.sendresponsemater_send_to_pricing {\n  margin-left: 10px;\n  background-color: #2563eb;\n  color: #fff;\n  padding: 0.6rem 1.5rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n/* Overlay */\n.sendresponsemater-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.sendresponsemater-pricing-list {\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  animation: fadeInScale 0.3s ease-in-out;\n}\n\n@keyframes fadeInScale {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.sendresponsemater-pricing-list-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.sendresponsemater-multiselect-wrapper {\n  margin-bottom: 1.5rem;\n}\n\n.sendresponsemater-multiselect-wrapper label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: #444;\n}\n\n.sendresponsemater-multiselect {\n  width: 100%;\n  height: 140px;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n  resize: vertical;\n  outline: none;\n}\n\n.sendresponsemater-multiselect option {\n  padding: 0.5rem;\n}\n\n.sendresponsemater-close-pricing-list,\n.sendresponsemater-send-to-pricing-btn {\n  background-color: #0052cc;\n  color: #fff;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  margin-left: 0.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.sendresponsemater-close-pricing-list {\n  background-color: #ccc;\n  color: #333;\n}\n\n.sendresponsemater-send-to-pricing-btn:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.sendresponsemater-close-pricing-list:hover {\n  background-color: #999;\n}\n\n.sendresponsemater-send-to-pricing-btn:hover:not(:disabled) {\n  background-color: #0040a0;\n}\n\n@media (max-width: 480px) {\n  .sendresponsemater-pricing-list {\n    padding: 1.2rem;\n  }\n\n  .sendresponsemater-pricing-list-title {\n    font-size: 1.25rem;\n  }\n\n  .sendresponsemater-multiselect {\n    height: 120px;\n  }\n\n  .sendresponsemater-close-pricing-list,\n  .sendresponsemater-send-to-pricing-btn {\n    width: 100%;\n    margin: 0.3rem 0;\n  }\n\n  div[style*=\"text-align: right\"] {\n    text-align: center !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
